/**
 * Retrieves the amount of items selected for purchase for a given identity
 *
 * @param {Array} cart the current cart
 * @param {Object} identity the identity to get packages for
 * @returns {number|*}
 */
export const getItemsCountByIdentity = (cart, identity) => {
  if (!identity) {
    return 0;
  }

  return cart.reduce((sum, item) => {
    if (!!item.type && item.identity?.id === identity.id) {
      return sum + (item.quantity ?? 1);
    }

    return sum;
  }, 0);
};

/**
 * Determines if a given user has purchased an albumFolderSubscription for the selected identity
 *
 * @param {Object} albumFolder the albumFolder
 * @param {Object} identity the identity to check for
 * @param {Array} selectedIdentities the selected identities
 *
 * @returns {boolean}
 */
export const hasPurchasedAlbumFolderIdentity = (
  albumFolder,
  identity,
  selectedIdentities,
) => {
  if (!albumFolder || !identity || selectedIdentities?.length === 0) {
    return false;
  }

  if (!albumFolder?.price?.value) {
    return false;
  }

  return !!selectedIdentities.find(
    selIdentity =>
      selIdentity.has_purchased_album_identity &&
      selIdentity.identity.id === identity.id,
  );
};
